/**
 * CSK Zero-Knowledge Compliance Proofs Demo — application shell (RD-25).
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import { createMonographRouteApp } from "../MonographRouteApp.js";
import { NAVIGATION } from "./data/nav.js";
import { panelTokens } from "@csk/demo-ui";

const zkpSurfaceTokens = {
  carrier: "#38bdf8",
  commit: "#818cf8",
  challenge: "#f59e0b",
  response: "#34d399",
  immune: "#34d399",
  immuneGreen: "#34d399",
  violation: "#fb7185",
  witness: "#22d3ee",
  predicate: "#c084fc",
  sealed: "#facc15",
};

export const App = createMonographRouteApp({
  navigation: NAVIGATION,
  theme: panelTokens,
  surfaceTokenAliases: [{ prefix: "zkp", tokens: zkpSurfaceTokens }],
  slug: "zero-knowledge-compliance",
  title: "Zero-Knowledge Compliance",
  eyebrow: "INTERACTIVE DEMO · RD-25",
  tagline:
    "Prove possession of a CSK witness — a PERMIT authority-DAG reachability path — without revealing the witness. Privacy-preserving compliance audit, grounded in structural soundness.",
  companionPath: "research/settled/RD-25-ZERO-KNOWLEDGE-COMPLIANCE-PROOFS.md",
  backgroundColor: "#0b0726",
});
